<template>
  <div class="inner-content">
    <!--<div class="b-gray-1 filter-wrp m-t-md m-b-20">-->
      <!--{{/**资讯*/}}-->
      <!--<div class="clearfix">-->
      <!--<div class="gray-4 pull-left">资讯：</div>-->
      <!--<div class="filter-content">-->
        <!--<span :class="{'filter-tag': true, 'active': index % 1}" v-for="(t, index) in tags">{{t}}</span>-->
      <!--</div>-->
    <!--</div>-->
    <!--</div>-->
    <div class="line2 m-t-30"></div>
    <div class="clearfix m-t-30">
      <div class="m-t-30" v-for="p in posterList" @click="goPosterDetail(p.uuid)">
        {{/** use background for image */}}
        <div class="clearfix news-info">
        <div class="f-5 pull-right m-t-89">浏览：{{p.viewNumber}}次</div>
        <div class="f-1 m-t-11">{{p.title}}</div>
        <div class="f-2 m-t-3">{{p.createTime.substring(0,10)}}</div>
        <div class="rectangle-theme f-3  m-t-12">{{p.themeTitle}}</div>
        <div class="line2 m-t-20"></div>
        <div class="rectangle-textarea f-4 clamp m-t-20" v-if="p.type === 4">{{p.content.text}}</div>
        <div class="rectangle-textarea f-4 clamp m-t-20" v-if="p.type !== 4">{{p.content[0].text}}</div>
      </div>
        <div class="img-n-div img-c-div" v-bind:style="{backgroundImage: 'url(' + p.cover + ')'}"></div>
        <div class="line2 m-t-30"></div>
      </div>
    </div>
    <pagination class="m-t-20 m-b-44" :pagination="pagination" :callback="loadData" :options="paginationOptions"></pagination>
  </div>
</template>
<script>
  import apiHelper from '../service/apiHelper';
  import pagination from '../reusable/Pagination';
  import { mixinPager } from '../reusable/pager';

  const vm = {
    name: 'News',
    mainService: apiHelper,
    service: 'homePosterList',
    dataKey: 'posterList',
    created() {
      this.pagination.per_page = 10;
    },
    data() {
      return {
        posterList: [],
        tags: ['全部资讯', '时尚新闻', '珠宝爱享', '美妆修身', '花饰甜品', '正式婚礼', '蜜月攻略', '心机指南', '爱将萌宠', '主题婚礼', '挚爱名师', '优选场地', '婚纱礼服'],
      };
    },
    components: {
      pagination,
    },
    methods: {
      goPosterDetail(id) {
        this.$router.push({ name: 'NewsDetail', params: { id } });
      },
    },
  };

mixinPager(vm);

export default vm;

</script>
<style scoped>

  .img-n-div {
    display: block;
    height: 220px;
    width: 35%;
    /*border: 1px solid gainsboro;*/
    box-sizing: border-box;
  }

  .img-c-div{
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }

  .news-info {
    display: block;
    box-sizing: border-box;
    width: 63%;
    float: right;
    /*vertical-align: middle;*/
  }

  .m-t-30 {
    margin-top: 30px;
  }

  .m-t-12 {
    margin-top: 12px;
  }

  .m-t-3 {
    margin-top: 3px;
  }

  .m-t-20 {
    margin-top: 20px;
  }

  .m-t-11 {
    margin-top: 11px;
  }

  .m-t-89 {
    margin-top: 89px;
  }

  .m-b-44 {
    margin-bottom: 44px;
  }

  .line2 {
    width: 100%;
    border-bottom: 1px #c1c1c1 dashed;
  }

  .f-1 {
    font-size: 18px;
    color: #252525;
    text-shadow: 0 1px 3px rgba(0, 0 , 0, 0.5);
    line-height: 25px;
  }

  .f-1:hover {
    font-size: 18px;
    color: #ba882a;
  }

  .f-1-selected {
    font-size: 18px;
    color: #ba882a;
  }

  .f-2 {
    font-size: 16px;
    color: #c1c1c1;
    line-height: 22px;
  }

  .f-3 {
    font-size: 14px;
    color: #df3a4e;
  }

  .f-4 {
    font-size: 12px;
    /*line-height: 22px;*/
    line-height: 1.83;
    color: #525252;
    font-weight: 300;
  }

  .f-5 {
    font-size: 12px;
    color: #a9a9a9;
    font-weight: 300;
    line-height: 17px;
  }

  .rectangle-theme {
    width: 99.8px;
    height: 28px;
    border-radius: 1px;
    border: solid 1px #df3a4e;
    text-align: center;
    line-height: 28px;
  }

  .rectangle-textarea {
    width: 100%;
  }

  .clamp {
    word-break:break-all;
    display:-webkit-box;
    -webkit-line-clamp:3;
    -webkit-box-orient:vertical;
    overflow:hidden;
  }
</style>



// WEBPACK FOOTER //
// News.vue?a0e6d3a8